
import { defineComponent, useMeta } from '@nuxtjs/composition-api'
import { stripTags } from '@zicht/nuxt-util'
import { getMediaSeoImage } from '~/assets/media'
import { setupTranslationPrefixer } from '~/assets/translation'
import relatedPages from '~/assets/relatedPages'

export default defineComponent({
  mixins: [relatedPages],
  props: {
    page: { type: Object, required: true },
  },
  setup(props) {
    // Build the Schema.org data
    const schemaDataAuthors =
      props.page.authors && props.page.authors.length > 0
        ? props.page.authors.map((author) => ({ '@type': 'Person', name: [author.firstName, author.insertion, author.lastName].filter((n) => n).join(' '), url: author.url }))
        : []
    const schemaData = {
      '@context': 'https://schema.org/',
      '@type': 'NewsArticle',
      url: props.page.url,
      headline: props.page.title,
      datePublished: new Date(props.page.postDate).toISOString(),
      articleBody: props.page.introduction ? stripTags(props.page.introduction) : null,
      author: schemaDataAuthors.length === 0 ? null : schemaDataAuthors.length === 1 ? schemaDataAuthors[0] : schemaDataAuthors,
      image: getMediaSeoImage(props.page.image).url,
    }
    useMeta({
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ type: 'application/ld+json', innerHTML: JSON.stringify(schemaData) }],
    })

    return {
      ...setupTranslationPrefixer('news-page'),
    }
  },
  head: {},
})
